
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import { AdminUser } from '../../services/userManagementService';
import { useTranslation } from 'react-i18next';

interface UserDeleteConfirmDialogProps {
  user: AdminUser | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (userId: string) => void;
  isDeleting: boolean;
}

const UserDeleteConfirmDialog: React.FC<UserDeleteConfirmDialogProps> = ({
  user,
  isOpen,
  onClose,
  onConfirm,
  isDeleting
}) => {
  const { t } = useTranslation();
  
  const handleConfirm = () => {
    if (user) {
      onConfirm(user.id);
      onClose();
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('modals.deleteConfirm.deleteUser')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('modals.deleteConfirm.deleteUserDescription', { name: user?.full_name || user?.email })}
            <br /><br />
            <strong>{t('modals.deleteConfirm.cannotUndo')}</strong>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('modals.deleteConfirm.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? t('modals.deleteConfirm.deleting') : t('modals.deleteConfirm.deleteUserButton')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default UserDeleteConfirmDialog;
